import {
  Alert,
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import styled from "@emotion/styled";
import React,{useState,useEffect} from "react";
import { height } from "@mui/system";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useNavigate } from "react-router-dom";
const Buttons=styled(Box)(({theme})=>({
    display:'flex',
    justifyContent:'flex-end',
    width:'100%',
    gap:'15px',
    margin:'10px 5px'

}))
const Wrapper=styled(Box)(({theme})=>({
  display:"flex",
  flexDirection:"column",
  gap:"20px",
  background:theme.palette.background.default,
  height:"100%",
  padding:"26px",
  borderRadius:"6px",
  boxShadow: `0px 0px 7px ${theme.palette.background.shadow}`,
}))
const StyledTextField=styled(TextField)(({theme})=>({
    "& label":{
        fontWeight: '400',
        fontSize: '18px',
        lineHeight: '20px',
    }
    

}))
function RejectRequest({close,doc_id,path}) {
 const navigate=useNavigate()
 const api=useAxiosPrivate()
 const [reason,setReason]=useState("")
 const reject=async()=>{
            api
          .patch(`request/officeReject/${doc_id}`,{reason:reason})
          .then((response) => {
            navigate(path, {state:{id:doc_id,message:"The agreement has been Rejected"}})
          })
 }
  return (
      <Box sx={{ minWidth: "40%", minHeight: "40%" }}>
        <Wrapper>      
         <StyledTextField
          fullWidth
          id="reject_reasom"
          label="Reject Reason"
          multiline
          rows={4}
          variant="standard"
          value={reason}
          onChange={(event) => {
    setReason(event.target.value);
  }}
        />
        <Buttons>
                <Button variant="contained"
                    size="medium"
                    sx={{
                    fontWeight: 400,
                    color:'#fff',
                    bgcolor:'gray',
                    "&:hover":{
                    bgcolor:'darkGray'}}}
                    onClick={()=>{close(false)}}
                >Cancel</Button>
                  <Button 
                  variant="contained"
                      size="medium"
                      sx={{
                      bgcolor:'secondary.main',
                      fontWeight: 400,
                      color:'#fff',
                      "&:hover":{
                      bgcolor:'secondary.hover',}, }}
                      onClick={()=>reject()}
                      >Submit </Button>
                
        </Buttons>
        </Wrapper>
      </Box>
  );
}

export default RejectRequest;
